import {Component, Vue} from 'vue-property-decorator';
import {DisplayEnum} from '@/types/enum';
import {
  SearchParams,
  FilterDataType,
  AllFilterDateMapping,
  SearchRespones,
  JudgementContents,
  JudgementSummaries,
} from '@/types/judgement';
import { convertProductUri, getLocalStorageMalls, toI18n } from '@/utils/commonUtils';
import {changeDateFormat} from '@/utils/dateUtils';
import {Mall, ContractedPartner, Mds, CustomProperty} from 'supporter';
import {escapeHtml} from '@/utils/commonUtils';
import {namespace} from 'vuex-class';
const termsModule = namespace('terms');

@Component
export default class JudgementListDataMixin extends Vue {
  @termsModule.Mutation('SET_NCPLAYERISEXIST') public setPopIsExist!: (isExist: boolean) => void;
  @termsModule.Mutation('SET_NCPLAYERISSHOW') public setPopIsShow!: (isExist: boolean) => void;
  @termsModule.Mutation('SET_POPINFO') public setPopInfo!: (popInfo: {}) => void;

  public today: string = changeDateFormat('', 'YYYY-MM-DD');

  public judgementContents: JudgementContents = {
    contents: [
    ],
    totalPage: 0,
    totalCount: 0
  }

  public judgementSummaries: JudgementSummaries = {
    countOfInspectionsOfManager: 0,
    countOnAfterApprovalReady: 0,
    countOnApprovalReady: 0,
  };

  public invalidKeywordSwitch = false;
  public invalidKeywordText = '';

  public readonly ALERT_MESSAGES = {
    chooseMall: this.$t('PRODUCT_PRODUCT_SELECT_MALL')
  };

  public searchParams: SearchParams = {
    mallNo: '',
    partnerNo: -100,
    adminNo: -100,
    applyStatus: '',
    keywords: '',
    periodType: 'LAST_UPDATE_DATE',
    searchStartDate: '',
    searchEndDate: '',
    keywordType: 'MALL_PRODUCT_NO',
    page: 1,
    size: 30
  };

  public searchParamsResetData = {...this.searchParams};

  public searchRespones: SearchRespones = {
    contents: [
    ],
    totalPage: 0,
    totalCount: 0
  };
  public getGridLayouts: any = [];

  public getProductDetailUrl({value, row}: any): string {
    const uri = convertProductUri(this.productDetailUrlObj[row.mallNo + ''], value)
    return `<a target="_blank" href="${uri}">${value}</a>`;
  }

  public productDetailUrlObj: {[propName: string]: string} = {};
  public applyStatusType: DisplayEnum[] = [
    {value: 'APPROVAL_READY,AFTER_APPROVAL_READY', label: this.toI18n('PRODUCT_PRODUCT_ALL_SELECT')},
    {value: 'APPROVAL_READY', label: this.toI18n('PRODUCT_PRODUCT_APPROVAL_WAIT')},
    {value: 'AFTER_APPROVAL_READY', label: this.toI18n('PRODUCT_PRODUCT_APPROVAL_WAIT_MODIFY')},
  ];
  public searchType: DisplayEnum[] = [
    {value: 'MALL_PRODUCT_NO', label: this.toI18n('PRODUCT_PRODUCT_MALL_PRODUCT_NO')},
    {value: 'PRODUCT_NAME', label: this.toI18n('PRODUCT_PRODUCT_PRODUCT_NAME')},
    {value: 'PRODUCT_MANAGEMENT_CD', label: this.toI18n('PRODUCT_PRODUCT_PRODUCT_MANAGEMENT_CD')},
    {value: 'PRODUCT_MANAGEMENT_CD_LIKE', label: this.toI18n('PRODUCT_PRODUCT_PRODUCT_MANAGEMENT_CD_PART')}
  ];

  public searchDateType: DisplayEnum[] = [
    {value: 'LAST_UPDATE_DATE', label: this.toI18n('PRODUCT_PRODUCT_LAST_UPDATE_DATE')},
    {value: 'REGISTER_DATE', label: this.toI18n('PRODUCT_PRODUCT_PRODUCT_REGISTER')},
    {value: 'SALE_START_DATE', label: this.toI18n('PRODUCT_PRODUCT_SALE_START_DATE')},
    {value: 'SALE_END_DATE', label: this.toI18n('PRODUCT_PRODUCT_SALE_END_DATE')},
  ];


  public filterDateData: FilterDataType[] = [
    {value: '0', label: this.toI18n('PRODUCT_PRODUCT_TODAY'), selected: false}, // 오늘
    {value: '1w', label: this.toI18n('PRODUCT_PRODUCT_ONE_WEEK'), selected: false}, // 1주일
    {value: '1m', label: this.toI18n('PRODUCT_PRODUCT_ONE_MONTH'), selected: false}, // 1개월
    {value: '3m', label: this.toI18n('PRODUCT_PRODUCT_THREE_MONTHS'), selected: true}, // 3개월
    {value: '6m', label: this.toI18n('PRODUCT_PRODUCT_SIX_MONTHS'), selected: false}, // 6개월
    {value: '1y', label: this.toI18n('PRODUCT_PRODUCT_ONE_YEAR'), selected: false} // 1년
  ];

  public filterDateMapping: AllFilterDateMapping = {
    '0': [0, 'd'],
    '1w': [-7, 'd'],
    '1m': [-1, 'M'],
    '3m': [-3, 'M'],
    '6m': [-6, 'M'],
    '1y': [-1, 'y'],
    ALL: [100, '']
  };

  public keywordTexthide: boolean = true;

  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t(needToI18nStr));
  }

  public mallInfo: Mall[] = getLocalStorageMalls();
  public get malls() : DisplayEnum[] {
    return [{value: '', label: '전체'}].concat(
      this.mallInfo.map(
        (mall: Mall): DisplayEnum => {
          return {value: mall.mallNo.toString(), label: mall.mallName};
        }
      )
    );
  }

  public isAllCheckBoxDisabled = false;

  public partnerList: ContractedPartner[] = [];
  public partnerInputVal: string = '';
  public partnerMenuIsShow = false;

  public adminList: Mds[] = [];
  public adminInputVal: string = '';
  public adminMenuIsShow = false;

  public categoiesCascade: any;

  public isCommissionTypeDisabled = false;
  public isSupplyPriceViewShow = false;
  public isCommissionRateView = false;
  public customProperties: CustomProperty[] = [];

  public gridHidden(type: boolean) {
    return type !== true;
  }

  public gridRefactory(str: string, type: boolean) {
    let gridData;
    switch (str) {
      case 'applyStatus':
        gridData =       {
          header: this.$t('PRODUCT_PRODUCT_ADMIT_STATUS'),
          name: 'applyStatus',
          minWidth: 120,
          align: 'center',
          ignored: true,
          hidden: this.gridHidden(type),
          visible: type,
          formatter: ({value}: any): any => {
            if (value === 'APPROVAL_READY') {
              return `<a href="javascript:void(0)">${this.$t('PRODUCT_PRODUCT_APPROVAL_WAIT')}</a>`;
            }

            if (value === 'AFTER_APPROVAL_READY') {
              return `<a href="javascript:void(0)">${this.$t('PRODUCT_PRODUCT_APPROVAL_WAIT_MODIFY')}</a>`;
            }

            return '';
          }
        }
        break
      case 'mallName':
        gridData =       {
          header: this.$t('PRODUCT_PRODUCT_MALL_NAME'),
          name: 'mallName',
          minWidth: 100,
          align: 'center',
          hidden: this.gridHidden(type),
          visible: type,
        }
        break
      case 'productNo':
        gridData =       {
          header: this.$t('PRODUCT_PRODUCT_MALL_PRODUCT_NO'),
          name: 'productNo',
          minWidth: 110,
          align: 'center',
          hidden: this.gridHidden(type),
          visible: type,
          formatter: this.getProductDetailUrl,
        }
        break
      case 'productName':
        gridData = {
          header: this.$t('PRODUCT_PRODUCT_PRODUCT_NAME'),
          name: 'productName',
          minWidth: 200,
          align: 'left',
          visible: type,
          hidden: this.gridHidden(type),
        }
        break
      case 'managementCode':
        gridData =       {
          header: this.$t('PRODUCT_PRODUCT_PRODUCT_MANAGEMENT_CD'),
          name: 'managementCode',
          minWidth: 120,
          align: 'left',
          visible: type,
          className: 'managementCode',
          hidden: this.gridHidden(type),
        }
        break
      case 'brandName':
        gridData =       {
          header: this.$t('PRODUCT_PRODUCT_BRAND'),
          name: 'brandName',
          minWidth: 120,
          align: 'left',
          visible: type,
          hidden: this.gridHidden(type),
          formatter: ({value}: any): string => {
            return escapeHtml(value);
          }
        }
        break
      case 'partnerName':
        gridData =       {
          header: this.$t('PRODUCT_PRODUCT_PARTNER_NAME'),
          name: 'partnerName',
          minWidth: 120,
          align: 'left',
          visible: type,
          className: 'partnerName',
          hidden: this.gridHidden(type),
        }
        break
      case 'representativeName':
        gridData =       {
          header: this.$t('PRODUCT_PRODUCT_ADMIN_NAME'),
          name: 'representativeName',
          minWidth: 120,
          align: 'center',
          visible: type,
          hidden: this.gridHidden(type),
        }
        break
      case 'commissionRate':
        gridData =       {
          header: this.$t('PRODUCT_PRODUCT_COMMISSION_RATE'),
          name: 'commissionRate',
          minWidth: 120,
          align: 'center',
          hidden: this.gridHidden(type),
          formatter: (data: any): any => {
            return `${data.value}%`;
          }
        }
        break
      case 'saleDateTime':
        gridData =       {
          header: this.$t('PRODUCT_PRODUCT_SALE_PERIOD'),
          name: 'saleDateTime',
          minWidth: 250,
          align: 'center',
          visible: type,
          hidden: this.gridHidden(type),
        }
        break
      case 'approvalRequestedDateTime':
        gridData =       {
          header: this.$t('PRODUCT_PRODUCT_APPROVAL_REQUESTED_DATETIME'),
          name: 'approvalRequestedDateTime',
          minWidth: 150,
          align: 'left',
          hidden: this.gridHidden(type),
          sortingType: 'desc',
          sortable: true,
        }
        break
      case 'registerDateTime':
        gridData =       {
          header: this.$t('PRODUCT_PRODUCT_PRODUCT_REGISTER'),
          name: 'registerDateTime',
          minWidth: 150,
          align: 'left',
          visible: type,
          hidden: this.gridHidden(type),
        }
        break
    }

    return gridData
  }

  public defaultDisplayOrder = [
    {
      columnName: 'applyStatus',
      order: 1,
      visible: true,
      displayName: this.$t('PRODUCT_PRODUCT_ADMIT_STATUS'),
      disabled: true,
    },
    {
      columnName: 'mallName',
      order: 2,
      visible: true,
      displayName: this.$t('PRODUCT_PRODUCT_MALL_NAME'),
      disabled: true
    },
    {
      columnName: 'productNo',
      order: 3,
      visible: true,
      displayName: this.$t('PRODUCT_PRODUCT_MALL_PRODUCT_NO'),
      disabled: true
    },
    {
      columnName: 'productName',
      order: 4,
      visible: true,
      displayName: this.$t('PRODUCT_PRODUCT_PRODUCT_NAME'),
      disabled: true
    },
    {
      columnName: 'managementCode',
      order: 5,
      visible: true,
      displayName: this.$t('PRODUCT_PRODUCT_PRODUCT_MANAGEMENT_CD'),
      disabled: false,
    },
    {
      columnName: 'brandName',
      order: 6,
      visible: true,
      displayName: this.$t('PRODUCT_PRODUCT_BRAND'),
      disabled: false,
    },
    {
      columnName: 'partnerName',
      order: 7,
      visible: true,
      displayName: this.$t('PRODUCT_PRODUCT_PARTNER_NAME'),
      disabled: false,
    },
    {
      columnName: 'representativeName',
      order: 8,
      visible: true,
      displayName: this.$t('PRODUCT_PRODUCT_ADMIN_NAME'),
      disabled: false,
    },
    {
      columnName: 'commissionRate',
      order: 9,
      visible: true,
      displayName: this.$t('PRODUCT_PRODUCT_COMMISSION_RATE'),
      disabled: false,
    },
    {
      columnName: 'saleDateTime',
      order: 10,
      visible: true,
      displayName: this.$t('PRODUCT_PRODUCT_SALE_PERIOD'),
      disabled: false,
    },
    {
      columnName: 'approvalRequestedDateTime',
      order: 10,
      visible: true,
      displayName: this.$t('PRODUCT_PRODUCT_APPROVAL_REQUESTED_DATETIME'),
      disabled: false,
    },
    {
      columnName: 'registerDateTime',
      order: 10,
      visible: true,
      displayName: this.$t('PRODUCT_PRODUCT_PRODUCT_REGISTER'),
      disabled: false,
    }
  ]

  public gridProps? = {
    columns: [],
    pageOptions: {
      page: 1,
      totalCount: 0,
      perPage: 30
    },
  }

  public gridOptions?: {[propName: string]: any} = {
    id: 'tui-grid-judgementlist',
    columnOptions: {
      minWidth: 70,
      resizable: true,
      frozenCount: 4
    },
    bodyHeight: 400,
    rowHeight: 31,
    minRowHeight: 35,
    displayRowCount: 20,
    isInitialRequest: true,
    copyOptions: {
      useFormattedValue: true
    },
    heightResizable: true,
    pageOptions: {
      centerAlign: true,
    },

  };
}
